import React, { useEffect } from 'react';
import { Form, Input } from 'antd';
import MyInput from '../Input';
import MySelect from '../Select';
import { selectPhoneCodes } from 'states/common/selectors';
import { createStructuredSelector } from 'reselect';
import { connect, useDispatch } from 'react-redux';
import { getPhoneCodes } from 'states/common/actions';
import PropTypes from 'prop-types';
import { PHONE_PATTERN } from 'constants/common';
import './styles.scss';

const MyPhoneInput = ({
  listPhoneCode,
  disabled,
  onPhoneCodeSelect,
  phoneName,
  codeName,
  onBlur,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (listPhoneCode.length) {
      return;
    }
    // dispatch(getPhoneCodes());
  }, []);

  return (
    <Input.Group compact>
      <div className="phone-input-custom">
        <div className="col-left">
          <Form.Item
            name={codeName}
            noStyle
            rules={[{ required: true, message: 'Please enter the phone code' }]}
          >
            <MySelect
              allowClear={false}
              placeholder="Phone code"
              disabled={disabled}
              showSearch
              className="select-custom-gray"
              options={listPhoneCode}
              onSelect={onPhoneCodeSelect}
            />
          </Form.Item>
        </div>
        <div className="col-right">
          <Form.Item
            name={phoneName}
            noStyle
            rules={[
              { required: true, message: 'Please enter your phone number' },
              {
                pattern: PHONE_PATTERN,
                message: 'Please enter the correct the phone number',
              },
            ]}
          >
            <MyInput
              disabled={disabled}
              type="number"
              placeholder="Enter phone number"
              onBlur={onBlur}
            />
          </Form.Item>
        </div>
      </div>
    </Input.Group>
  );
};

MyPhoneInput.propTypes = {
  disabled: PropTypes.bool,
  phoneData: PropTypes.object,
  codeName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  phoneName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onBlur: PropTypes.func,
};

MyPhoneInput.defaultProps = {
  disabled: false,
  phoneData: null,
  codeName: ['phoneData', 'code'],
  phoneName: ['phoneData', 'number'],
  onBlur: () => {},
};

const mapStateToProps = createStructuredSelector({
  listPhoneCode: selectPhoneCodes(),
});

export default connect(mapStateToProps, null)(MyPhoneInput);

